import React from "react";
import AddOnPurchaseProductCard from "./AddOnPurchaseProductCard";
import type { AddOnPurchaseListProps } from "./types";

const AddOnPurchaseProductList: React.FC<AddOnPurchaseListProps> = ({ products, ...cardProps }) => (
  <div className="productList">
    {products.map((product) => (
      <AddOnPurchaseProductCard key={`${product.category || ""}_${product.sku}`} product={product} {...cardProps} />
    ))}
  </div>
);
export default AddOnPurchaseProductList;
